import type React from 'react';
import { useContext } from 'react';

import { RuleEditorDrawer } from '../../../settings/automation-rules/modals/rule-editor-drawer';
import { AutomationRulesContext } from '../../../settings/automation-rules/context';
import { PlaybookCards } from './cards/playbook-cards';

import style from './automation-playbooks.module.less';

export const AutomationPlaybooks: React.FC = () => {
  const { isDrawerOpen } = useContext(AutomationRulesContext);

  return (
    <>
      <div className={style['automation-playbooks']}>
        <PlaybookCards />
      </div>
      {isDrawerOpen && <RuleEditorDrawer />}
    </>
  );
};
